import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MemberRecord } from '../../../../models/users/dto/member-record';

@Component({
  selector: 'app-ip-member-overview-card',
  templateUrl: './ip-member-overview-card.component.html',
  styleUrls: ['./ip-member-overview-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IpMemberOverviewCardComponent {
  @Input() member!: MemberRecord;
  @Input() isLoading: boolean = false;
}
